import { publicAssetsURL } from '#build/paths.mjs';export default publicAssetsURL("/nuxt-assets/images/logo/big-pilulka.svg")